<template>
    <div class="add">
        <el-radio-group @input='radioChange' size="medium" v-model="loadOption">
            <el-radio-button class="button" v-for="(item,index) in mergeData" :key="index" :label="item">
                <div class="flex">
                    <div class="nameSex">{{item.ctmName}}</div>
                    <div class="nameSex">{{item.ctmMobile}}</div>
                    <div class="nameSex">{{item.ctmCode}}</div>
                    <el-button size="mini" type="danger" @click.prevent="editRemoveDomain(item,index)">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </div>
            </el-radio-button>
        </el-radio-group>
        <el-form class="formInline" ref="formInline" :model="formInline" label-width="100px">
            <el-form-item label="姓名">
                <el-input v-model="formInline.ctmName" placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item label="常用手机号">
                <el-input v-model="formInline.ctmMobile" placeholder="常用手机号"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer partFooter">
            <el-button type="danger" @click="cancel">取 消</el-button>
            <el-button type="primary" @click="doAddgoods('mergeData')">确 定</el-button>
        </div>
    </div>
</template>
<script>
export default {
    props: ['mergeData'],

    data() {
        return {
            loadOption: this.mergeData[0],
            formInline: {
                ctmName: this.mergeData[0].ctmName,
                ctmMobile: this.mergeData[0].ctmMobile,
                ctmCode: this.mergeData[0].ctmCode,
                ctmId: this.mergeData[0].ctmId,
                ctmSex: this.mergeData[0].ctmSex,
            },
        }
    },

    methods: {
        radioChange(val) {
            this.formInline = JSON.parse(JSON.stringify(val))
        },
        doAddgoods() {
            // console.log(this.formInline);
            // console.log(this.mergeData);
            let userCode = []
            userCode = this.mergeData.map((item) => {
                return item.ctmCode;
            })
            console.log(userCode);
            let data = {
                codeList: userCode.toString(),
                customerInfo: this.formInline
            }
            api.requestQuiet("/customer/updateCustomerInfoMerge", data, (res) => {
                if (res.result == true) {
                    this.$emit("close");
                    this.$emit("add-comment");
                    this.$emit('changeSelection')
                    _g.toast("success", '合并成功');
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { });
        },
        cancel() {
            this.$emit("close");
        },
        // 删除当前客户
        editRemoveDomain(item, listIndex) {
            var index = this.mergeData.indexOf(item)
            if (index !== -1) {
                this.mergeData.splice(listIndex, 1)
            }
        },
    }
}
</script>
<style scoped>
.nameSex {
  margin: 0 10px;
  font-size: 16px;
}
.flex {
  /* width: 90%; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button {
  display: flex;
  width: 100%;
}
.add >>> .el-radio-button--medium .el-radio-button__inner {
  width: 100%;
}
.add >>> .el-radio-button__inner,
.el-radio-group {
  width: 100%;
}
.formInline {
  margin-top: 10px;
}
</style>


